<template>
  <div class="hab-detail-policy color-light-black">
    <loading v-if="isLoading" />
    <div v-else-if="!isLoading" class="policy">
      <p v-if="schedules && !schedules?.refundable" class="m-0 p-0 text-center">
        <span class="ph-8 pv-20 status radius-5 fill style-border-dashed-gray"
          >Không thể hoàn hủy</span
        >
      </p>
      <div v-if="schedules && schedules?.refundable === 1">
        <p class="text-18-700 color-light-black">
          {{ $t("detail.cs_huy_ve") }}
        </p>
        <div class="ticket-table">
          <table>
            <thead>
              <tr>
                <th>{{ $t("detail.huy_tu") }}</th>
                <th>{{ $t("detail.den_truoc") }}</th>
                <th>{{ $t("detail.phi_huy") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(policyCance, index) in policyCancellation?.detail"
                :key="index"
              >
                <td>{{ renderCancel(policyCance, "CancelWord") }}</td>
                <td>
                  {{ renderCancel(policyCance, "ComeFirst") }}
                  <!-- renderTripStart -->
                </td>
                <td>{{ renderCancel(policyCance, "CancellationFee") }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p
          class="mt-12"
          v-if="policyCancellation?.note || policyCancellation?.english_note"
        >
          <strong class="mr-4">{{ $t("detail.ghi_chu") }}:</strong
          >{{
            locale === "vn"
              ? policyCancellation?.note
              : policyCancellation?.english_note
          }}
        </p>
      </div>
      <p
        v-if="dataSource && dataSource?.length !== 0"
        class="text-18-700 color-light-black mt-16"
      >
        {{ $t("detail.cs_nha_xe") }}
      </p>
      <ul
        v-if="dataSource && dataSource?.length !== 0"
        class="hab-detail-policy__list"
      >
        <li v-for="(item, index) in dataSource" :key="index">
          <h5 class="text-16-700 color-light-black m-0 mb-4">
            {{ renderLocaleText(item) }}
          </h5>
          <ul
            v-if="item?.details && item?.details?.length !== 0"
            class="color-light-black"
          >
            <li v-for="(detail, index2) in item?.details" :key="index2">
              <p>{{ renderLocaleText(detail, ["title", "english_title"]) }}</p>
              <div
                v-html="
                  renderLocaleText(detail, ['content', 'english_content'])
                "
                class="hab-detail-policy__content"
              />
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { renderLocaleText } from "../../../../utils/helpers";
import loading from "../../../loading/index";

export default {
  components: {
    loading,
  },
  props: {
    schedules: {
      type: Object,
      default: null,
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    policyCancellation: {
      type: Object,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    renderLocaleText:
      (event) =>
      (value, fields = ["name", "english_name"]) => {
        return renderLocaleText(value, event.locale, fields);
      },
    renderCancel: (event) => (value, type) => {
      if (value.from === 0) {
        if (type === "CancelWord") {
          return moment(event?.policyCancellation?.trip_date).isValid()
            ? moment(event?.policyCancellation?.trip_date)
                .add(-value.to, "H")
                .format("DD/MM/YYYY HH:mm")
            : "";
        } else if (type === "ComeFirst") {
          return event.$t("detail.gio_khoi_hanh");
        } else {
          return `${value?.fee}${value?.currency_description}`;
        }
      } else if (value.from && value.to) {
        if (type === "CancelWord") {
          return moment(event?.policyCancellation?.trip_date).isValid()
            ? moment(event?.policyCancellation?.trip_date)
                .add(-value.to, "H")
                .format("DD/MM/YYYY HH:mm")
            : "";
        } else if (type === "ComeFirst") {
          return moment(event?.policyCancellation?.trip_date).isValid()
            ? moment(event?.policyCancellation?.trip_date)
                .add(-value.from, "H")
                .format("DD/MM/YYYY HH:mm")
            : "";
        } else {
          return `${value?.fee}${value?.currency_description} ${event.$t(
            "detail.gia_tri_don_hang"
          )}`;
        }
      } else if (value.from && !value.to) {
        if (type === "CancelWord") {
          return `${value.from} ${event.$t(
            "detail.tieng_truoc_khi_khoi_hanh"
          )}`;
        } else if (type === "ComeFirst") {
          return "";
        } else if (type === "CancellationFee" && value?.fee) {
          return `${value?.fee}${value?.currency_description} ${event.$t(
            "detail.gia_tri_don_hang"
          )}`;
        } else {
          return event.$t("detail.mien_phi");
        }
      } else if (!value.from && value.to) {
        if (type === "CancelWord") {
          const newValue = value.to;
          return moment(event?.policyCancellation?.trip_date).isValid()
            ? moment(event?.policyCancellation?.trip_date)
                .add(-newValue, "H")
                .format("DD/MM/YYYY HH:mm")
            : "";
        } else if (type === "ComeFirst") {
          return moment(event?.policyCancellation?.trip_date).isValid()
            ? moment(event.policyCancellation.trip_date).format(
                "DD/MM/YYYY HH:mm"
              )
            : "";
        } else {
          return `${value?.fee}${value?.currency_description} ${event.$t(
            "detail.gia_tri_don_hang"
          )}`;
        }
      }

      return "";
    },
    // renderTripStart() {
    //   return moment(this.policyCancellation?.trip_date).isValid()
    //     ? moment(this.policyCancellation?.trip_date).format("DD/MM/YYYY HH:mm")
    //     : "";
    // },
  },
  data() {
    return {
      locale: locale,
    };
  },
};
</script>
